export function getDisplayMessage(selectedMonth, selectedYear, actualEndMonth = null) {
  const currentYear = new Date().getFullYear();
  const currentMonthName = new Date().toLocaleString('default', { month: 'long' });
  if (selectedMonth === 'YTD') {
    const endMonth = actualEndMonth || (Number(selectedYear) === currentYear ? currentMonthName : 'December');
    if (endMonth === 'January') {
      return `Displaying data for January ${selectedYear}`;
    }
    return `Displaying data from January to ${endMonth} ${selectedYear}`;
  } else {
    return `Displaying data for ${selectedMonth} ${selectedYear}`;
  }
}
 